/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Venue_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Venue name" |
*
* @param {Tfield_Venue_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_venue_placeholder = /** @type {((inputs?: Tfield_Venue_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Venue_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du lieu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de la sede")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome do local")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome della sede")
	return /** @type {LocalizedString} */ ("Venue name")
});